module.exports = __webpack_public_path__ + "img/tv.53be35cf.svg";